import React from 'react'
import '../../styles/css/Card.css';
import {  WEB_AUTH_URL } from "../../configurations/paths.config"
import { removeAuth } from '../../services/Auth/auth.service';

function Logout() {     
    let queryStatus = new URLSearchParams(window.location.search).get('stats')

    if (queryStatus !== null && queryStatus !== undefined) {
        if (queryStatus.toLowerCase() === "success") {
            removeAuth();
            window.location.href = WEB_AUTH_URL
        } else { 
            //window.location.replace(WEB_CORE_URL)
        }
    }
    else {
        //window.location.replace(WEB_CORE_URL)
    }

    return (
        <>

        </>
    );
}

export default Logout;